const CategoryChoosed = (  state = false, action  ) => {
    if ( action.type === 'categorychoosed' ) {
        return action.payload
    } else {
        return state
    }
}
export default CategoryChoosed